import "./BundleSelector.scss";

import React from "react";
import { Dropdown, MenuItem, Popover, OverlayTrigger } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import * as articleUtils from "../../../../../utils/articleUtils";
import * as _ from "lodash";
import TrackingUtil from "shared/src/utils/TrackingUtil";

const renderDropdownMenuItem = function (
    text: string,
    index: string,
    listOfArticles: Array<{
        [x: string]: any;
    }>,
    selection: string | undefined | null
) {
    let message: React.ReactNode = text;
    let checked = false;
    if (selection && index === selection) {
        message = (
            <span>
                {text} (<FormattedMessage id="EX_ORIGINAL_ARTICLE_NOT_BUYABLE" />
                )&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
        );
        checked = true;
    } else if (articleUtils.containsBettyBundleId(index, listOfArticles)) {
        message = (
            <span>
                {text} (<FormattedMessage id="EX_ARTICLE_ALREADY_IN_LIST" />
                )&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
        );
        checked = true;
    }
    return (
        <MenuItem key={index} className={"sd-bundle-selector-menuitem"} eventKey={index}>
            {message}
            {checked ? <i className="icon-check icon-lg" /> : null}
        </MenuItem>
    );
};

const renderDropdowns = function (
    items: {
        [x: string]: string;
    },
    listOfArticles: Array<{
        [x: string]: any;
    }>,
    selection: string | undefined | null
) {
    try {
        const sortedPairs = _.sortBy(_.toPairs(items), (pair) => pair[0]);
        return _.map(sortedPairs, (pair) => renderDropdownMenuItem(pair[1], pair[0], listOfArticles, selection));
    } catch (e) {
        const message = "Render dropdowns failed.";
        TrackingUtil.trackUiErrorSd("BundleSelector", message, e);
        return undefined;
    }
};

function BundleSelector(props: { [x: string]: any }) {
    const items = props.items;

    if (!items || _.isEmpty(items)) {
        console.warn("Selector's items list is empty");
        return <div className="loading" />;
    }

    // disable, if told to do so
    let disabled = props.disabled;
    let hideCaret = false;
    // or if there is only one and pre-selected possibility
    if (_.size(items) === 1 && props.selection) {
        hideCaret = true;
        disabled = true;
    }

    const id =
        props.numberOfAdditionalBundles > 1
            ? "EX_MORE_BUNDLES_AVAILABLE_FOR_THIS_ARTICLE"
            : "EX_ONE_MORE_BUNDLE_AVAILABLE_FOR_THIS_ARTICLE";
    //pullRight in Dropdown because: if there is long text for the bundle size (eg "135er Display mit Artikelauflösung"),
    //the text won't float out of the screen on the right but expand left
    const dropdown = (
        <Dropdown
            className="btex-bundle-selector dropbutton btn-block"
            id={"exBundleSelectorDropdownForArticle" + props.id}
            onSelect={props.onSelect}
            disabled={disabled}
            pullRight>
            <Dropdown.Toggle
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                block
                noCaret={hideCaret}>
                <div className="sd-bundle-selector-toggle">
                    <FormattedMessage id={id} values={{ number: props.numberOfAdditionalBundles }} />
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderDropdowns(items, props.listOfArticles, props.selection)}</Dropdown.Menu>
        </Dropdown>
    );

    if (!props.showOtherBundle) {
        return dropdown;
    } else {
        const nbuyPopover = (
            <Popover id={"bundleNotBuyablePopover" + props.id} className="nbuypop">
                <FormattedMessage id="EX_POPOVER_BUNDLECHANGED_NOT_BUYABLE" />
            </Popover>
        );
        return (
            <OverlayTrigger placement="top" trigger={["click", "hover"]} overlay={nbuyPopover}>
                {dropdown}
            </OverlayTrigger>
        );
    }
}

export default BundleSelector;
